export enum PassSettingsPageTabs {
  INFORMATION = 'information',
  PRICING = 'pricing',
  SETTINGS = 'settings',
  DELETION = 'deletion',
}
